import { LEADERSHIP_TIER } from '@/constants/leadership-tier';
import { fetchMe } from '@/services/api/me';
import { useAuthStore } from '@/stores/auth.store';
import type { AuthUser } from '@/types/auth';

export function isLeadershipTierLoaded(user: AuthUser): boolean {
  return user.leadershipTier !== undefined;
}

export async function hydrateAuthLeadershipTier(): Promise<AuthUser | null> {
  const { user, patchUser } = useAuthStore.getState();
  if (!user) {
    return null;
  }

  if (isLeadershipTierLoaded(user)) {
    return user;
  }

  try {
    const profile = await fetchMe();
    patchUser({ leadershipTier: profile.leadershipTier });
    return { ...user, leadershipTier: profile.leadershipTier };
  } catch {
    patchUser({ leadershipTier: LEADERSHIP_TIER.NONE });
    return { ...user, leadershipTier: LEADERSHIP_TIER.NONE };
  }
}

export async function enrichAuthUserWithLeadershipTier(user: AuthUser): Promise<AuthUser> {
  if (isLeadershipTierLoaded(user)) {
    return user;
  }

  try {
    const profile = await fetchMe();
    return { ...user, leadershipTier: profile.leadershipTier };
  } catch {
    return { ...user, leadershipTier: LEADERSHIP_TIER.NONE };
  }
}
